export const Images = [
  "./assets/images/photos/kayal.jpg",
  "./assets/images/photos/temple.jpg",
  "./assets/images/photos/sea_3.jpg",
  "./assets/images/photos/sea_2.jpg",
  "./assets/images/photos/sea.jpg",
  "./assets/images/photos/sea_1.jpg",
  "./assets/images/photos/flower_1.jpg",
  "./assets/images/photos/flower.jpg",
  "./assets/images/photos/light_house.jpg",
  "./assets/images/photos/lights.jpg",
  "./assets/images/photos/frnd.jpg",
  "./assets/images/photos/led.jpg",
  "./assets/images/photos/lamp.jpg",
  "./assets/images/photos/mall.jpg",
  "./assets/images/photos/lamp_1.jpg",
  // "./assets/images/photos/mac.jpg",
  //   "./assets/images/photos/night_light.jpg",
  // "./assets/images/photos/dry.jpg",
  "./assets/images/photos/work_station.jpg",
  "./assets/images/photos/work_station.jpg",
  "./assets/images/photos/work_station.jpg",
];

export const Videos = [
  {
    id: 1,
    url: "https://www.instagram.com/reel/C1BkLIbPtGz/?utm_source=ig_web_copy_link",
  },
  {
    id: 2,
    url: "https://www.instagram.com/reel/DBETNtfAd0K/?utm_source=ig_web_copy_link",
  },
  {
    id: 3,
    url: "https://www.instagram.com/reel/DA1BhKlSCoR/?utm_source=ig_web_copy_link",
  },
  {
    id: 4,
    url: "https://www.instagram.com/reel/C-ow29VyQM4/?utm_source=ig_web_copy_link",
  },
  {
    id: 5,
    url: "https://www.instagram.com/reel/C_sVlcISAWu/?utm_source=ig_web_copy_link",
  },
  {
    id: 6,
    url: "https://www.instagram.com/reel/C_m5_BhRvrz/?utm_source=ig_web_copy_link",
  },
  {
    id: 7,
    url: "https://www.instagram.com/reel/C_fpo6JvxEM/?utm_source=ig_web_copy_link",
  },
  {
    id: 8,
    url: "https://www.instagram.com/reel/C-sgZCGPs0u/?utm_source=ig_web_copy_link",
  },
  {
    id: 9,
    url: "https://www.instagram.com/reel/C89iXAcyQj9/?utm_source=ig_web_copy_link",
  },
  {
    id: 10,
    url: "https://www.instagram.com/reel/C5Xr8_hv0V5/?utm_source=ig_web_copy_link",
  },
  {
    id: 11,
    url: "https://www.instagram.com/reel/C5ThJgVvUYQ/?utm_source=ig_web_copy_link",
  },
  {
    id: 12,
    url: "https://www.instagram.com/reel/C2b5YnFITV9/?utm_source=ig_web_copy_link",
  },
  {
    id: 13,
    url: "https://www.instagram.com/reel/C8RgDKISFOI/?utm_source=ig_web_copy_link",
  },
  {
    id: 14,
    url: "https://www.instagram.com/reel/C6EaCEAPZyl/?utm_source=ig_web_copy_link",
  },
  {
    id: 15,
    url: "https://www.instagram.com/reel/C3fFq5kPHUL/?utm_source=ig_web_copy_link",
  },
  {
    id: 16,
    url: "https://www.instagram.com/reel/C2pEiQevcj1/?utm_source=ig_web_copy_link",
  },
  {
    id: 17,
    url: "https://www.instagram.com/reel/C0Jt5f3vl-k/?utm_source=ig_web_copy_link",
  },
  {
    id: 18,
    url: "https://www.instagram.com/reel/CvCfRy8AqrY/?utm_source=ig_web_copy_link",
  },
  {
    id: 19,
    url: "https://www.instagram.com/reel/CutwmLQAlgP/?utm_source=ig_web_copy_link",
  },
  {
    id: 20,
    url: "https://www.instagram.com/reel/CteHKUCpaYS/?utm_source=ig_web_copy_link",
  },
  {
    id: 21,
    url: "https://www.instagram.com/reel/CtYPj0KggUF/?utm_source=ig_web_copy_link",
  },
  {
    id: 22,
    url: "https://www.instagram.com/reel/CsigBiAAiX6/?utm_source=ig_web_copy_link",
  },
  {
    id: 23,
    url: "https://www.instagram.com/reel/CneaULmgr27/?utm_source=ig_web_copy_link",
  },
  {
    id: 24,
    url: "https://www.instagram.com/reel/Cm3oMigg0L3/?utm_source=ig_web_copy_link",
  },
  {
    id: 25,
    url: "https://www.instagram.com/reel/CmilaFhAPCp/?utm_source=ig_web_copy_link",
  },
  {
    id: 26,
    url: "https://www.instagram.com/reel/ClXuczQr_iH/?utm_source=ig_web_copy_link",
  },
  {
    id: 27,
    url: "https://www.instagram.com/reel/ClSnQrtgZmu/?utm_source=ig_web_copy_link",
  },
  {
    id: 28,
    url: "https://www.instagram.com/reel/Cj2H_yPAAIB/?utm_source=ig_web_copy_link",
  },
  {
    id: 29,
    url: "https://www.instagram.com/reel/Cjxff7BgedI/?utm_source=ig_web_copy_link",
  },
  {
    id: 30,
    url: "https://www.instagram.com/reel/Cq7QBkYOwC2/?utm_source=ig_web_copy_link",
  },
  {
    id: 31,
    url: "https://www.instagram.com/reel/CrDkNccrxbH/?utm_source=ig_web_copy_link",
  },
  {
    id: 32,
    url: "https://www.instagram.com/reel/CjFitbkD34B/?utm_source=ig_web_copy_link",
  },
  {
    id: 33,
    url: "https://www.instagram.com/reel/Ci6rsYlgMZq/?utm_source=ig_web_copy_link",
  },
  {
    id: 34,
    url: "https://www.instagram.com/reel/CgZc9QUPkuh/?utm_source=ig_web_copy_link",
  },
  {
    id: 35,
    url: "https://www.instagram.com/reel/CeacOJ5FxLA/?utm_source=ig_web_copy_link",
  },
  {
    id: 36,
    url: "https://www.instagram.com/reel/CyaNTkJxO4P/?utm_source=ig_web_copy_link",
  },
  {
    id: 37,
    url: "https://www.instagram.com/reel/C90APS5Sw97/?utm_source=ig_web_copy_link",
  },
];
